<script>
  import { Save, Trash2 } from 'lucide-svelte';

  export let formId = null;
  export let onDeleteMenu = () => {};
  export let onSaveMenu = () => {};

  const buttonBase =
    'inline-flex h-10 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60';
</script>

<div class="mb-5 flex flex-col gap-4 border-b border-slate-200 pb-5 sm:flex-row sm:items-start sm:justify-between">
  <div class="min-w-0">
    <h2 class="text-lg font-semibold text-slate-900">Menu Detail</h2>
    <p class="mt-1 text-sm text-slate-500">Configure menu settings</p>
  </div>

  <div class="flex flex-col gap-2 sm:flex-row">
    {#if formId}
      <button class={`${buttonBase} border border-red-200 bg-white text-red-600 hover:bg-red-50`} type="button" on:click={onDeleteMenu}>
        <Trash2 size={16} />
        Delete
      </button>
    {/if}

    <button class={`${buttonBase} bg-blue-600 text-white shadow-sm hover:bg-blue-700`} type="button" on:click={onSaveMenu}>
      <Save size={16} />
      Save
    </button>
  </div>
</div>
